import s from './DealsBoard.scss'
import { DraggableBoard } from 'components/common/DraggableBoard'
import { LaneHeader } from 'components/common/LaneHeader'
import { DealCard } from './DealCard'
import { useOutletContext } from 'react-router-dom'

const DealsBoard = () => {
  const {
    onLaneScroll,
    changeStatus,
    boardData,
    toggleSelectAllDeals,
    addBoardColumnRef,
    boardHeaders,
    updateDealsStatusFollowupDate,
    navigateTo,
    dealsStatuses,
    toggleSelectDeal,
    updateDraggedDealFollowupDate,
    expandCard
  } = useOutletContext()
  return (
    <div className={s.boardWrapper}>
      <DraggableBoard
        onLaneScroll={onLaneScroll}
        onDragEnd={changeStatus}
        data={boardData}
        customLaneHeader={
          <LaneHeader
            toggleSelectAllDeals={toggleSelectAllDeals}
            addBoardColumnRef={addBoardColumnRef}
            dataType="deal"
            hasActions
            boardHeaders={boardHeaders}
            updateDealsStatusFollowupDate={updateDealsStatusFollowupDate}
          />
        }
      >
        <DealCard
          navigateTo={navigateTo}
          dealsStatuses={dealsStatuses}
          toggleSelectDeal={toggleSelectDeal}
          updateDealFollowupDate={updateDraggedDealFollowupDate}
          expandCard={expandCard}
        />
      </DraggableBoard>
    </div>
  )
}

export default DealsBoard
